"use client";

import { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "../store/store";
import { loadWeddingState } from "./persistence";
import { hydrateWeddingState, setHydrationComplete } from "./features/weddingSlice";

export function StoreProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const persistedState = loadWeddingState();
    if (persistedState) {
      store.dispatch(hydrateWeddingState(persistedState));
    }
    store.dispatch(setHydrationComplete(true));
  }, []);

  return <Provider store={store}>{children}</Provider>;
}
